import { RouteObject } from 'react-router-dom'
import { PageLoadingSupport, LoadedPageContent } from '../../../common/app'
import { default as Roster } from '.'

const basePath = '/time/roster'
export const rosterRoutes: RouteObject[] = [
  {
    path: `${basePath}/:rosterId/publish`,
    element: (
      <PageLoadingSupport>
        <Roster.Publish.Component />
      </PageLoadingSupport>
    ),
    loader: Roster.Publish.Loader,
  },
  {
    path: `${basePath}/templates`,
    element: (
      <LoadedPageContent title={'Roster Templates'} displayLeftTitle={false}>
        <Roster.Templates.Component />
      </LoadedPageContent>
    ),
    loader: Roster.Templates.Loader,
  },
  {
    path: `${basePath}/copy`,
    element: (
      <PageLoadingSupport>
        <Roster.Copy.Component />
      </PageLoadingSupport>
    ),
    loader: Roster.Copy.Loader,
  },
]
